import {createContext, useState} from "react";

export const CLEARING_SYSTEM_HOME_PAGE = "clearingSystem-home";
export const CLEARING_SYSTEM_CREATE_PAGE = "clearingSystem-create";

export const Context = createContext({});

const initClearingSystemFilterState = {
    clearingSystemCode: '',
    clearingSystemId: '',
    agentName: ''
}

const initClearingSystemResultsDisplay = {
    search: {},
    resData: []
}

const initClearingSystemPanelPageState = {
    currentPage: CLEARING_SYSTEM_HOME_PAGE,
}

export const Provider = props => {

    const {children, startOnCreate = false} = props;
    const [clearingSystemFilterState, setClearingSystemFilterState] = useState(JSON.parse(JSON.stringify(initClearingSystemFilterState)));
    const [clearingSystemResultsDisplayState, setClearingSystemResultsDisplayState] = useState(JSON.parse(JSON.stringify(initClearingSystemResultsDisplay)));
    const [clearingSystemPanelPageState, setClearingSystemPanelPageState] = useState(JSON.parse(JSON.stringify({
        ...initClearingSystemPanelPageState,
        currentPage: startOnCreate ? CLEARING_SYSTEM_CREATE_PAGE : CLEARING_SYSTEM_HOME_PAGE
    })));
    const [showGridToolbar, setShowGridToolbar] = useState(true);

    // Edit popup state
    const [showEdit, setShowEdit] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const clearClearingSystemPanelDisplayState = () => {
        setClearingSystemFilterState(JSON.parse(JSON.stringify(initClearingSystemFilterState)));
        setClearingSystemResultsDisplayState(JSON.parse(JSON.stringify(initClearingSystemResultsDisplay)));
        setClearingSystemPanelPageState(JSON.parse(JSON.stringify(initClearingSystemPanelPageState)));
    }

    const displayClearingSystemPanelPage = (clearingSystemPanelPage) => {
        let stateToShow = JSON.parse(JSON.stringify(clearingSystemPanelPageState));
        stateToShow.currentPage = clearingSystemPanelPage;
        setClearingSystemPanelPageState(stateToShow);
    }

    const clearingSystemPanelContext = {
        clearingSystemFilterState,
        setClearingSystemFilterState,
        clearingSystemResultsDisplayState,
        setClearingSystemResultsDisplayState,
        clearingSystemPanelPageState,
        setClearingSystemPanelPageState,
        showGridToolbar,
        setShowGridToolbar,
        showEdit,
        setShowEdit,
        selectedRecord,
        setSelectedRecord,
        displayClearingSystemPanelPage,
        clearClearingSystemPanelDisplayState
    }

    return <Context.Provider value={clearingSystemPanelContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;

